angular
  .module('contrast.services.search', [])
  .factory(
    'SearchService',
    function ($filter, searchTypes, UserService, ProfileService) {
      'ngInject'

      return {
        transformSearchResults: transformSearchResults,
        getResultFormat: getResultFormat,
        getSecondaryInfo: getSecondaryInfo,
        getResultLink: getResultLink
      }

      function transformSearchResults(results) {
        var transformedResults = [],
          resultList = [],
          result = undefined

        for (var i = 0; i < results.length; i++) {
          resultList = results[i].items

          for (var j = 0; j < resultList.length; j++) {
            result = resultList[j]
            result.searchItemType = results[i].searchItemType
            result.mainInfo = getResultFormat(result)
            result.secondaryInfo = getSecondaryInfo(result)
            transformedResults.push(result)
          }
        }

        return transformedResults
      }

      function getResultFormat(result) {
        switch (result.searchItemType) {
          case searchTypes.org.apps:
            return result.name

          case searchTypes.org.servers:
            return result.name

          case searchTypes.org.libs:
            return result.file_name

          case searchTypes.org.vulns:
            return result.title

          case searchTypes.org.threats:
            return result.source_ip

          default:
            return undefined
        }
      }

      function getSecondaryInfo(result) {
        switch (result.searchItemType) {
          case searchTypes.org.apps:
            return result.path + ' (' + result.language + ')'

          case searchTypes.org.servers:
            return result.path

          case searchTypes.org.libs:
            return (
              result.version +
              ' (' +
              getFormattedDate(result.release_date) +
              ')'
            )

          case searchTypes.org.vulns:
            return result.app_name + ' - ' + result.uuid

          case searchTypes.org.threats:
            var appName = ''
            if (result.app_names && result.app_names.length > 0) {
              appName = result.app_names[0]
              if (result.app_names.length > 1) {
                appName += ' + ' + (result.app_names.length - 1) + ' more'
              }
            }
            return appName + ' - ' + result.uuid

          default:
            return undefined
        }
      }

      function getResultLink(result) {
        var path

        switch (result.searchItemType) {
          case searchTypes.org.apps:
            path = UserService.buildUrl('/applications/' + result.app_id)
            break

          case searchTypes.org.servers:
            path = UserService.buildUrl(
              '/servers/' + result.server_id + '/overview'
            )
            break

          case searchTypes.org.libs:
            var agentLangDescToAgentLang = {
              Java: 'JAVA',
              '.NET': 'DOTNET',
              '.NET Core': 'DOTNET_CORE',
              Node: 'NODE'
            }

            path = UserService.buildUrl(
              `/libraries?filterText=${result.file_name}&showPanel=true&activeRow=${result.hash}|${result.app_language}`
            )

            break

          case searchTypes.org.vulns:
            path = UserService.buildUrl('/vulns/' + result.uuid + '/overview')
            break

          case searchTypes.org.threats:
            path = UserService.buildUrl('/attacks/' + result.uuid + '/overview')
            break

          default:
            path = ''
        }

        return path
      }

      function getFormattedDate(date) {
        var dateFormat = ProfileService.getDateFormat()
        return $filter('date')(date, dateFormat)
      }
    }
  )
